import { type ComponentRef, Directive, input, output, type Type } from '@angular/core';
import { outputToObservable } from '@angular/core/rxjs-interop';
import { ContextMenuDirective } from '@frontendlib/components/features/popover/directives/context-menu.directive';
import { takeUntil } from 'rxjs/operators';
import { BoardsFolderContextMenuComponent } from './boards-folder-context-menu/boards-folder-context-menu.component';
import { type BoardFolder } from '../../types/board';

/** Right-click menu of a board folder in the Boards sidebar, like a notebook's or a Files folder's. */
@Directive({
  selector: '[appBoardsFolderContextMenu]',
  standalone: true,
})
export class BoardsFolderContextMenuDirective extends ContextMenuDirective {
  public readonly appBoardsFolderContextMenu = input.required<BoardFolder>();
  public readonly appBoardsFolderContextMenuOpen = output<boolean>();
  public readonly appBoardsFolderContextMenuBoardCreated = output<string>();
  public readonly appBoardsFolderContextMenuDeleted = output<void>();
  public readonly appBoardsFolderContextMenuDuplicated = output<string>();

  protected registerComponent(): Type<BoardsFolderContextMenuComponent> {
    return BoardsFolderContextMenuComponent;
  }

  protected registerInstance(componentRef: ComponentRef<BoardsFolderContextMenuComponent>): void {
    componentRef.setInput('folder', this.appBoardsFolderContextMenu());
    const instance = componentRef.instance;
    outputToObservable(instance.open).pipe(takeUntil(this.alive)).subscribe(selectAll => this.appBoardsFolderContextMenuOpen.emit(selectAll));
    outputToObservable<string>(instance.boardCreated).pipe(takeUntil(this.alive)).subscribe((id) => this.appBoardsFolderContextMenuBoardCreated.emit(id));
    outputToObservable(instance.deleted).pipe(takeUntil(this.alive)).subscribe(() => this.appBoardsFolderContextMenuDeleted.emit());
    outputToObservable<string>(instance.duplicated).pipe(takeUntil(this.alive)).subscribe((id) => this.appBoardsFolderContextMenuDuplicated.emit(id));
  }
}
